type Step = {
  title: string;
  body: string;
};

const STEPS: Step[] = [
  {
    title: 'Rate your team',
    body: "Our AI scores your squad in seconds and shows exactly where it's leaking points."
  },
  {
    title: 'Make the right transfer',
    body: "AI Transfers picks the best move for your team, not generic tips for everyone else's."
  },
  {
    title: 'Watch it pay off live',
    body: 'Live points faster than the official FPL app, and your mini-league goal by goal, in the Fantasy Football Hub app.'
  }
];

const HEADING_ID = 'how-you-beat-your-mates-heading';

const formatStepNumber = (index: number): string =>
  String(index + 1).padStart(2, '0');

const HowYouBeatYourMates = () => (
  <section aria-labelledby={HEADING_ID} className="bg-white">
    <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 lg:py-16">
      <h2
        id={HEADING_ID}
        className="font-sans text-2xl font-bold leading-8 text-landing-ink lg:text-[28px] lg:leading-9"
      >
        How you beat your mates
      </h2>
      <ol className="mt-6 grid gap-4 md:grid-cols-3 md:gap-5">
        {STEPS.map((step, index) => (
          <li
            key={step.title}
            className="rounded-xl border border-landing-hairline bg-white p-5 shadow-100"
          >
            <span className="font-open-sans text-xs font-bold tracking-[.08em] text-primary-700">
              {formatStepNumber(index)}
            </span>
            <h3 className="mt-2 font-sans text-lg font-semibold leading-6 text-landing-ink">
              {step.title}
            </h3>
            <p className="mt-2 font-open-sans text-sm leading-6 text-landing-slate">
              {step.body}
            </p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowYouBeatYourMates;
